import { FC, useEffect, useState } from 'react';
import {
  Box,
  Card,
  Typography,
  Grid,
  Tabs,
  Tab
} from '@mui/material';

import ResourceTable from './ResourceTable';
import ProjectTable from './ProjectTable';
import ResourcePoolDashboard from './ResourcePoolDashboard';

interface ResourcePoolProps {
  permissions: any;
  tab: string
}

const ResourcePoolView: FC<ResourcePoolProps> = ({ permissions, tab }) => {
  const tabIds: String[] = ['resource', 'project'];
  const [tabValue, setTabValue] = useState<any>(tab ? tab : null);

  useEffect(() => {
    setTabValue(tab ? tab : null);
  }, [tab])

  //set tabs value
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <div className='resource-pool'>
      <div>
        <iframe
          title="frame"
          id="my_iframe"
          style={{ display: 'none' }}
        ></iframe>
        <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
          <Grid item>
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              Resource {tabValue ? ' Management' : ' Dashboard'}
            </Typography>
            <Typography variant="subtitle2"></Typography>
          </Grid>
        </Grid>
      </div>
      <Card>
        { tabValue ?
          <Box>
            <Box sx={{ width: '100%', boxShadow: 'inset 0 -1px 0 #eee' }} px={2}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="wrapped label tabs example"
              >
                {permissions.some(
                  (perm) =>
                    perm.name === 'View Resources' && perm.value === true
                ) && <Tab value="resource" label="Resources" /> }
                {permissions.some(
                  (perm) =>
                    perm.name === 'View Projects' && perm.value === true
                ) && <Tab value="project" label="Projects" /> }
              </Tabs>
            </Box>
            {tabValue === tabIds[0] && <ResourceTable/>}
            {tabValue === tabIds[1] && <ProjectTable/>}
          </Box>
           : 
           permissions.some(
              (perm) =>
                perm.name === 'View Dashboard' && perm.value === true
            ) && <ResourcePoolDashboard permissions={permissions}/> 
        }
      </Card>
    </div>
  );
};

export default ResourcePoolView;
